import {
	InvoiceStatus,
	InvoiceEditApplyTemplateModalInvoiceTemplateFragment,
} from '#types';
import { gql } from '@apollo/client';
import { ArrayElement } from '../../lib/helpers/apollo';

export type CreateOrUpdateInvoiceHandler = ( options?: {
	skipSuccessPun?: boolean;
	intendToSend: boolean;
} ) => Promise<
| { id: string; status: InvoiceStatus; eventDate?: string | Date | null }
| false
>;

/* PLEASE NOTE: we've only added support for countOfConnectedInvoices on InvoiceTemplate
to getInvoiceTemplatesWhere. Other relations using that calculated value won't work */

export const invoiceEditApplyTemplateModalInvoiceTemplateFragment = gql`
	fragment invoiceEditApplyTemplateModalInvoiceTemplate on InvoiceTemplate {
		id
		title
		notes
		allowsGratuity
		automatedRemindersEnabled
		discountAmount
		discountIsPercentage
		discountPercentage
		filename
		lineItems {
			id
			order
			name
			rate
			quantity
			taxPercentage
			notes
		}
		paymentInstallments {
			id
			name
			amountDue
			enteredAsPercentageAmount
			percentageDue
		}
	}
`;

export type InvoiceTemplate = Omit<
InvoiceEditApplyTemplateModalInvoiceTemplateFragment,
'__typename' | 'lineItems' | 'paymentInstallments'
> & {
	lineItems: Omit<
	ArrayElement<
	InvoiceEditApplyTemplateModalInvoiceTemplateFragment['lineItems']
	>,
	'__typename'
	>[];
} & {
	paymentInstallments: Omit<
	ArrayElement<
	InvoiceEditApplyTemplateModalInvoiceTemplateFragment['paymentInstallments']
	>,
	'__typename'
	>[];
};
